import React from "react";
import { Chip } from "@mui/joy";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import VerifiedIcon from "@mui/icons-material/Verified";
import type { LinkedinConfidenceLevel } from "./AutodbTooltipWrapper";

interface LinkedInConfidenceBadgeProps {
  level: LinkedinConfidenceLevel | null;
}

const LinkedInConfidenceBadge: React.FC<LinkedInConfidenceBadgeProps> = ({
  level,
}) => {
  if (!level) return null;

  if (level === "low")
    return (
      <Chip
        size="sm"
        color="danger"
        variant="soft"
        startDecorator={<WarningAmberIcon sx={{ fontSize: 14 }} />}
      >
        Low confidence
      </Chip>
    );

  if (level === "medium")
    return (
      <Chip size="sm" color="warning" variant="soft">
        Medium confidence
      </Chip>
    );

  return <VerifiedIcon sx={{ fontSize: 16, color: "success.500" }} />;
};

export default LinkedInConfidenceBadge;
